// extracted by mini-css-extract-plugin
module.exports = {"item":"NavItem_item__CksCt","title":"NavItem_title__XOIVF","icon":"NavItem_icon__86CfG"};